import { render, staticRenderFns } from "./ComponentVideoOverlay.vue?vue&type=template&id=df1c298a&scoped=true&"
import script from "./ComponentVideoOverlay.vue?vue&type=script&lang=js&"
export * from "./ComponentVideoOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ComponentVideoOverlay.vue?vue&type=style&index=0&id=df1c298a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1c298a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
